"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.EnvironmentDeleteView = void 0;
var _react = require("react");
var _main = require("../../../main");
var _useTeacherApi = require("../hooks/useTeacherApi");
var _EnvironmentManager = require("../EnvironmentManager.provider");
var _jsxRuntime = require("react/jsx-runtime");
const EnvironmentDeleteView = props => {
  const {
    environmentTitle,
    isLearingSite,
    onClose,
    onDelete
  } = props;
  const {
    environmentData,
    userEnvironments,
    getLabel,
    setPreloaderMode,
    setSliderView,
    resetEnvironment,
    setSrcEnvironmentId,
    setUserEnvironments
  } = (0, _react.useContext)(_EnvironmentManager.EnvironmentManagerContext);
  const {
    deleteEnviroment
  } = (0, _useTeacherApi.useTeacherApi)(isLearingSite);
  const [viewMode, setViewMode] = (0, _react.useState)('confirm_delete');
  const [deletedEnvironmentTitle, setDeletedEnvironmentTitle] = (0, _react.useState)();
  const onConfirmDelete = async () => {
    setPreloaderMode('over');
    setDeletedEnvironmentTitle(environmentTitle);
    const isEnviromentDeleted = await deleteEnviroment(environmentData);
    if (isEnviromentDeleted) {
      setViewMode('deleted');
      onDelete?.(environmentData);
      setTimeout(() => {
        setUserEnvironments(userEnvironments ? userEnvironments.filter(e => e.Ids.Id !== environmentData.Ids.Id) : []);
        setSrcEnvironmentId();
      }, 500);
    } else {
      setViewMode('not_deleted');
    }
    setPreloaderMode(undefined);
  };
  return /*#__PURE__*/(0, _jsxRuntime.jsxs)("div", {
    "data-testid": "environmentDeleteView",
    children: [/*#__PURE__*/(0, _jsxRuntime.jsx)(_main.Modal.Header, {
      messageIcon: "Trash",
      messageType: viewMode === 'deleted' ? 'success' : 'alert',
      title: deletedEnvironmentTitle ? deletedEnvironmentTitle : environmentTitle,
      message: getLabel(viewMode === 'confirm_delete' ? 'environment_confirm_delete' : viewMode === 'deleted' ? 'environment_deleted' : 'environment_not_deleted')
    }), /*#__PURE__*/(0, _jsxRuntime.jsxs)(_main.Modal.Content, {
      children: [/*#__PURE__*/(0, _jsxRuntime.jsx)(_jsxRuntime.Fragment, {
        children: viewMode === 'confirm_delete' && /*#__PURE__*/(0, _jsxRuntime.jsx)("p", {
          children: getLabel('confirm_delete_message')
        })
      }), /*#__PURE__*/(0, _jsxRuntime.jsx)(_jsxRuntime.Fragment, {
        children: viewMode === 'not_deleted' && /*#__PURE__*/(0, _jsxRuntime.jsx)("p", {
          children: getLabel('environment_not_deleted_support')
        })
      })]
    }), /*#__PURE__*/(0, _jsxRuntime.jsx)(_main.Modal.Footer, {
      justifyContent: "space-between",
      children: viewMode === 'confirm_delete' ? /*#__PURE__*/(0, _jsxRuntime.jsxs)(_jsxRuntime.Fragment, {
        children: [/*#__PURE__*/(0, _jsxRuntime.jsx)(_main.Modal.Footer.Section, {
          children: /*#__PURE__*/(0, _jsxRuntime.jsx)(_main.Button, {
            view: "outlined",
            onClick: () => {
              setDeletedEnvironmentTitle(undefined);
              setSliderView('main');
            },
            children: getLabel('back')
          })
        }), /*#__PURE__*/(0, _jsxRuntime.jsx)(_main.Modal.Footer.Section, {
          children: /*#__PURE__*/(0, _jsxRuntime.jsx)(_main.Button, {
            view: "contained",
            onClick: () => {
              onConfirmDelete();
            },
            children: getLabel('confirm')
          })
        })]
      }) : /*#__PURE__*/(0, _jsxRuntime.jsxs)(_jsxRuntime.Fragment, {
        children: [/*#__PURE__*/(0, _jsxRuntime.jsx)(_main.Modal.Footer.Section, {
          children: /*#__PURE__*/(0, _jsxRuntime.jsx)(_main.Button, {
            view: "outlined",
            onClick: () => {
              onClose();
            },
            children: getLabel('close')
          })
        }), /*#__PURE__*/(0, _jsxRuntime.jsx)(_main.Modal.Footer.Section, {
          children: /*#__PURE__*/(0, _jsxRuntime.jsx)(_main.Button, {
            view: "contained",
            onClick: () => {
              setSliderView('main');
              resetEnvironment();
              setTimeout(() => {
                setDeletedEnvironmentTitle(undefined);
                setViewMode('confirm_delete');
              }, 500);
            },
            children: getLabel('update_another_environment')
          })
        })]
      })
    })]
  });
};
exports.EnvironmentDeleteView = EnvironmentDeleteView;